<template>
  <el-container class="layout-container">
    <el-header>
      <div class="header-logo">后台管理系统</div>
      <div class="header-user">
        <span>欢迎，{{ username }}</span>
        <el-button type="danger" size="small" @click="handleLogout">退出登录</el-button>
      </div>
    </el-header>
    
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="collapse-btn" @click="toggleCollapse">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
        <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          :collapse="isCollapse"
          @select="handleMenuSelect">
          <el-menu-item index="/dashboard">
            <i class="el-icon-s-home"></i>
            <span slot="title">控制面板</span>
          </el-menu-item>
          <el-menu-item index="/users">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/products">
            <i class="el-icon-s-goods"></i>
            <span slot="title">产品管理</span>
          </el-menu-item>
          <el-menu-item index="/vip-products">
            <i class="el-icon-star-on"></i>
            <span slot="title">VIP卡片管理</span>
          </el-menu-item>
          <el-submenu index="orders">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>订单管理</span>
            </template>
            <el-menu-item index="/orders/pledge">
              <i class="el-icon-document"></i>
              <span slot="title">质押订单</span>
            </el-menu-item>
            <el-menu-item index="/orders/withdraw">
              <i class="el-icon-money"></i>
              <span slot="title">提现订单</span>
            </el-menu-item>
            <el-menu-item index="/orders/deposit">
              <i class="el-icon-wallet"></i>
              <span slot="title">充值订单</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/settings">
            <i class="el-icon-setting"></i>
            <span slot="title">系统设置</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
      <el-container class="main-container">
        <!-- 标签页 -->
        <el-header height="40px" class="tabs-header">
          <el-tabs 
            v-model="activeTab" 
            type="card" 
            closable 
            @tab-remove="removeTab"
            @tab-click="clickTab">
            <el-tab-pane
              v-for="item in tabs"
              :key="item.path"
              :label="item.title"
              :name="item.path">
            </el-tab-pane>
          </el-tabs>
        </el-header>
        
        <!-- 内容区域 -->
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      username: localStorage.getItem('username') || '管理员',
      activeMenu: '/dashboard',
      activeTab: '/dashboard',
      isCollapse: false,
      tabs: [
        {
          title: '控制面板',
          path: '/dashboard'
        }
      ]
    }
  },
  methods: {
    handleLogout() {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除登录信息
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        
        // 跳转到登录页
        this.$router.push('/login')
        
        this.$message({
          type: 'success',
          message: '已退出登录'
        })
      }).catch(() => {
        // 取消退出
      })
    },
    
    // 处理菜单选择
    handleMenuSelect(index) {
      this.activeMenu = index
      this.activeTab = index
      
      // 如果标签不存在，则添加新标签
      const isExist = this.tabs.some(item => item.path === index)
      if (!isExist) {
        let title = ''
        switch (index) {
          case '/dashboard':
            title = '控制面板'
            break
          case '/users':
            title = '用户管理'
            break
          case '/products':
            title = '产品管理'
            break
          case '/vip-products':
            title = 'VIP卡片管理'
            break
          case '/orders/pledge':
            title = '质押订单'
            break
          case '/orders/withdraw':
            title = '提现订单'
            break
          case '/orders/deposit':
            title = '充值订单'
            break
          case '/settings':
            title = '系统设置'
            break
          default:
            title = '新标签'
        }
        
        this.tabs.push({
          title,
          path: index
        })
      }
      
      // 路由跳转
      this.$router.push(index)
    },
    
    // 移除标签
    removeTab(targetPath) {
      // 如果关闭的是当前激活的标签
      if (this.activeTab === targetPath) {
        // 找到被关闭标签的索引
        const tabs = this.tabs
        let activeIndex = 0
        
        for (let i = 0; i < tabs.length; i++) {
          if (tabs[i].path === targetPath) {
            activeIndex = i
            break
          }
        }
        
        // 如果还有其他标签
        if (tabs.length > 1) {
          // 如果关闭的是最后一个标签，则激活前一个标签
          if (activeIndex === tabs.length - 1) {
            this.activeTab = tabs[activeIndex - 1].path
          } else {
            // 否则激活后一个标签
            this.activeTab = tabs[activeIndex + 1].path
          }
          
          // 路由跳转
          this.$router.push(this.activeTab)
        }
      }
      
      // 从标签数组中移除
      this.tabs = this.tabs.filter(tab => tab.path !== targetPath)
      
      // 如果没有标签了，添加默认的控制面板标签
      if (this.tabs.length === 0) {
        this.tabs.push({
          title: '控制面板',
          path: '/dashboard'
        })
        this.activeTab = '/dashboard'
        this.$router.push('/dashboard')
      }
    },
    
    // 点击标签
    clickTab(tab) {
      this.activeMenu = tab.name
      this.$router.push(tab.name)
    },

    // 根据路由路径获取标签标题
    getTabTitle(path) {
      let title = ''
      
      switch (path) {
        case '/dashboard':
          title = '控制面板'
          break
        case '/users':
          title = '用户管理'
          break
        case '/products':
          title = '产品管理'
          break
        case '/vip-products':
          title = 'VIP卡片管理'
          break
        case '/orders/pledge':
          title = '质押订单'
          break
        case '/orders/withdraw':
          title = '提现订单'
          break
        case '/orders/deposit':
          title = '充值订单'
          break
        case '/settings':
          title = '系统设置'
          break
        default:
          title = '新标签'
      }
      
      return title
    },

    // 切换菜单展开/收起
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    }
  },
  created() {
    // 初始化当前激活的菜单和标签
    this.activeMenu = this.$route.path
    this.activeTab = this.$route.path
    
    // 如果当前路径不是默认的控制面板，添加对应的标签
    if (this.$route.path !== '/dashboard') {
      let title = ''
      switch (this.$route.path) {
        case '/users':
          title = '用户管理'
          break
        case '/products':
          title = '产品管理'
          break
        case '/vip-products':
          title = 'VIP卡片管理'
          break
        case '/orders/pledge':
          title = '质押订单'
          break
        case '/orders/withdraw':
          title = '提现订单'
          break
        case '/orders/deposit':
          title = '充值订单'
          break
        case '/settings':
          title = '系统设置'
          break
        default:
          title = '新标签'
      }
      
      // 检查标签是否已存在
      const isExist = this.tabs.some(item => item.path === this.$route.path)
      if (!isExist) {
        this.tabs.push({
          title,
          path: this.$route.path
        })
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.el-header {
  background-color: #304156;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-logo {
  font-size: 18px;
  font-weight: bold;
}

.header-user {
  display: flex;
  align-items: center;
  gap: 15px;
}

.el-aside {
  background-color: #304156;
  color: white;
  transition: width 0.3s;
  position: relative;
}

.collapse-btn {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #bfcbd9;
  font-size: 20px;
  transition: background-color 0.3s;
}

.collapse-btn:hover {
  background-color: #263445;
}

.sidebar-menu {
  height: calc(100% - 40px);
  border-right: none;
}

.sidebar-menu:not(.el-menu--collapse) {
  width: 200px;
}

.main-container {
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
}

.tabs-header {
  background-color: #fff;
  padding: 0;
  line-height: 40px;
  height: 40px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.el-tabs {
  height: 40px;
}

.el-tabs__header {
  margin: 0;
}

.el-main {
  padding: 0;
  overflow-x: hidden;
}
</style> 